<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Type of activities">
            <input [(ngModel)]="exemption.activityType" id="activityType" maxlength="256" type="text"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Name of company carrying out activities">
            <input [(ngModel)]="exemption.nameOfCompany" id="nameOfCompany" maxlength="256" type="text"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Start Operations">
            <app-date-field [(ngModel)]="exemption.from" id="from" required></app-date-field>
          </app-form-group>
          <app-form-group label="End Operations">
            <app-date-field [(ngModel)]="exemption.to" id="to" required></app-date-field>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Has a task risk analysis  been drawn up ?">
            <app-yes-no [(ngModel)]="exemption.hasRiskAnalysisBeenDrawnUp" id="hasRiskAnalysisBeenDrawnUp"
                        required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Have risks arising from the task risk analysis been identified ?">
            <app-yes-no [(ngModel)]="exemption.haveRisksBeenIdentified" id="haveRisksBeenIdentified"
                        required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
